import { define } from 'wicked-elements'
import onIntersect from '../lib/on-intersect.js'

define('[data-component~="ultralazy"]', {
  init () {
    this.state = {}
    this.onEnter = this.onEnter.bind(this)
    this.onLoad = this.onLoad.bind(this)
  },
  connected () {
    this.stopObserving = onIntersect(this.element, {
      root: this.element.closest('[data-scroll-parent]'),
      rootMargin: '500px 0px 500px 0px'
    }, this.onEnter)
    this.element.addEventListener('load', this.onLoad)
  },
  disconnected () {
    this.stopObserving()
  },
  onEnter (e) {
    this.load()
    this.stopObserving()
  },
  load () {
    this.element.classList.remove('lazyload')
    this.element.classList.add('lazyloading')

    const newSrc = this.element.dataset.src
    if (newSrc) this.element.src = newSrc

    const newSrcset = this.element.dataset.srcset
    if (newSrcset) {
      if (this.element.dataset.sizes === 'auto') {
        this.element.sizes = `${this.element.offsetWidth}px`
      }
      this.element.srcset = newSrcset
    }
  },
  onLoad () {
    this.element.classList.remove('lazyloading')
    this.element.classList.add('lazyloaded')
  }
})